export var VERSION = "1.3.4";
//# sourceMappingURL=version.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@appsignal/javascript/dist/esm/version.js
// module id = 1238
// module chunks = 0